import { useSeriesCardContext } from './series-card'
import { SeriesCardOverlay } from './series-card-overlay'
import React, { ReactNode } from 'react'
import { ImagePublicFileId } from 'src/component/image/image-public-file-id'
import { cn } from 'src/lib/utils'

interface SeriesCardImageProps {
  children?: ReactNode
  className?: string
}

export const SeriesCardImage = ({ children, className }: SeriesCardImageProps): React.ReactElement => {
  const { series } = useSeriesCardContext()

  return (
    <>
      <ImagePublicFileId fileId={series.imagePublicFileId} className={cn('w-full h-full object-cover object-top', className)} />
      {children && <SeriesCardOverlay>{children}</SeriesCardOverlay>}
    </>
  )
}
